import Vue from "vue";
import Router from "vue-router";
import packages from "../modules";

import Home from "../static/Home.vue";
import HowTo from "../static/HowTo.vue";
import About from "../static/About.vue";
import Contact from "../static/Contact.vue";
import CookiesPolicy from "../static/CookiesPolicy.vue";
import NotFound from "../static/NotFound.vue";

Vue.use(Router);

export default new Router({
    // mode: 'history',
    base: process.env.BASE_URL,
    routes: [{
            path: '/',
            name: "Home",
            component: Home,
            children: [{
                    path: "profile",
                    name: "Profile",
                }, {
                    path: "rooms",
                    name: "Rooms",
                }, {
                    path: "members",
                    name: "Members",
                }, {
                    path: "setting",
                    name: "Setting",
                }, {
                    path: "search",
                    name: "Search",
                },
                // *************************** // 
                {
                    path: "dashboard",
                    name: "Dashboard",
                },
                // *************************** // 
                {
                    path: "room/:id",
                    name: "Room",
                }, {
                    path: "search/:target",
                    name: "SearchRooms",
                }, {
                    path: "profile/:username",
                    name: "visitProfile",
                }

            ]
        }, {
            path: '/setting',
            name: "Setting",
            component: Home,
        }, {
            path: '/howto',
            name: "HowTo",
            component: HowTo,
        }, {
            path: '/about',
            name: "About",
            component: About,
        }, {
            path: "/contact",
            name: "Contact",
            component: Contact,

        }, {
            path: "/cookies-policy",
            name: "CookiesPolicy",
            component: CookiesPolicy
        },
        ...packages.routre,
        {
            path: "/notfound?:error",
            name: "NotFound",
            component: NotFound
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return { selector: to.hash }
        } else {
            return { x: 0, y: 0 }
        }
    }
});